// @flow
import { List } from "immutable"
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"

import User from "../../records/User"
import Balance from "../../records/Balance"

// eslint-disable-next-line flowtype/no-weak-types
export default function mapperUser(input: Object, currencies: FetchedCurrencies): User {
  // eslint-disable-line flowtype/no-weak-types
  return new User({
    id: input.user_id, // string
    email: input.email, // string
    token: input.token, // string

    verified: input.email_verified, // bool

    firstname: input.first_name, // string
    lastname: input.last_name, // string

    apiToken: input.search_token, // string
    affiliateId: input.affiliate_id, // string

    cardDiscount: input.card_payment_discount,
    balanceDiscount: input.credits_payment_discount,
    balances: List(input.accounts)
      .map(
        balance =>
          new Balance({
            amount: balance.user_credits, // string
            currency: balance.currency.toLowerCase(), // float
          }),
      )
      // Filters balances, which are stored in currently ignored currencies
      .filter(balance => Boolean(currencies[balance.currency])),
  })
}
